export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/cal-6c81e95ba24f063bb2d19180135dbba1.png";